export const VideosTranslations = {
    videosTranslations:{
        pageTitle: 'Videos',
        banner: {
            title: 'Música que recordamos ft. John Van Beek',
            description: 'Music We Remember es una serie exclusiva de conciertos en vivo con música de John Van Beek',
            button: 'Empezar a mirar'
        },
    }
}